angular.module("currencyInput.components", []).component("currencyInput", {
  templateUrl: "ng/components/currencyInput/currencyInput.view.html",
  bindings: {
    /** Input data **/
    inputId: "@",
    inputName: "@",
    inputClass: "@",
    formName: "=",
    bindingVariable: "=",
    /** Optional data **/
    inputDisableOn: "<",
    inputRequired: "<",
    type: "@",
    inputPlaceholder: "@",
    showOn: "<",
    up: "<",
    unique: "<",
    pfIdentifier: "@",
    changes: "&?",
    errorDirection: "@",
    inputTabindex: "@",
    hideMexError: "<",
    initialBindingVariable: "<",
    minValue: "=",
    maxValue: "=",
    /** Disable target on viewvalue present */
    elementToDisable: "@",
    checkWholeForm: "@",
    activeOnlyOnblur: '<',
    checkValidity: '<',
    notVisualTriangle: '<',
    notEraseValueWhenDisable: '=',
    automaticVisualErrorMessage: '<',
    maxLengthInputBox: '<'
  },
  controllerAs: "currencyInputCtrl",
  controller: function (
    validationService,
    verifyUniqueService,
    $componentUtility
  ) {
    /** not to loose *this reference **/
    var self = this;

    self.initialized = false;

    self.errorMsgShown = false;

    self.valid = true;

    var setValidity = function (bool) {
      if (self.formName && self.inputName && self.formName[self.inputName]) {
        self.formName[self.inputName].$setValidity(self.type, !!bool);
        self.valid = !!bool;
      }
    };

    self.$onInit = function () {
      self.hideMexError = self.hideMexError || false;
      self.verifyUnique = true;
      //Quando viene costruito, check immediato sulla validità
      self.checkGeneric(self.bindingVariable || undefined);

      self.initialized = true;
      self.errorMsgShown = !!self.automaticVisualErrorMessage;
    };

    self.$onChanges = function (changes) {

      if (changes.checkValidity && typeof changes.checkValidity != "undefined") {
        if (changes.checkValidity.currentValue != changes.checkValidity.previousValue) {
          setValidity(changes.checkValidity.currentValue);
        }
      }

      if (changes.inputDisableOn && typeof changes.inputDisableOn.currentValue != "undefined") {
        jQuery('#' + self.inputId).prop("disabled", !!changes.inputDisableOn.currentValue);
      }


      //Quando l'input si disabilita:
      //1. sbianco il valore
      //2. richiamo il changes per riflettere il cambiamento
      if (
        self.initialized &&
        changes.inputDisableOn &&
        changes.inputDisableOn.currentValue &&
        !changes.inputDisableOn.previousValue &&
        !self.notEraseValueWhenDisable
      ) {
        self.model = undefined;

        //Chiamo changes
        self.changes &&
          self.changes({
            name: self.inputName,
            value: ""
          });
      }
    };

    self.resetAlert = function () {
      self.errorMsgShown = false;
    };

    self.toggleAlertMsg = function () {
      self.errorMsgShown = !self.errorMsgShown;
    };

    self.hasError = function () {
      return !self.valid;
    };

    self.checkGeneric = function (generic, typeOfCall) {
      if (!self.initialized) return;

      /**
       * 2 CASI:
       * 1. generic == undefined
       *  1.1 generic required => non corretto
       *  1.2 generic not required => corretto
       * 2. generic != undefined => corretto
       */
      if (typeof generic == "undefined") {
        setValidity(false);

        self.changes &&
          self.changes({
            name: self.inputName,
            value: self.bindingVariable
          });

        self.verifyUnique = true;

        return;
      } else {
        //setValidity(!self.inputRequired);

        self.changes &&
          self.changes({
            name: self.inputName,
            value: self.bindingVariable
          });
        setValidity(true);

        return;
      }

    };

  }
});